export const readyApp = () => {
    return {
        type: "app/READY"
    }
}
